import React, { Fragment, useEffect, useRef } from 'react';
import { CountUp } from 'components';
import { mount } from './mount';
import { useInView } from 'helpers';
import * as css from 'styles/program/single.scss';

let counter = 0;

export const TextBig = mount('text-big', props => {
  const [ refView, inView ] = useInView({ triggerOnce: true });
  const [ _, value, suffix ] = /^(\d+)(.*)/.exec(props.innerHTML.trim()) || [];
  if (value) {
    return (
      <span ref={refView}>
        { inView
          ? <CountUp end={parseInt(value)} duration={0.5+0.15*counter++} suffix={suffix} />
          : '0'.concat(suffix)
        }

      </span>
    );
  }
  return (
    <span dangerouslySetInnerHTML={{__html: props.innerHTML }} />
  );
});
